import React from "react";
import IconButton from "@mui/material/IconButton";
import { formatRelativeTime } from "utils/formatRelativeTime";

const NotificationCard = React.forwardRef(function NotificationCard(
  { notification, isUnread, onClick, onClose, variant, heading },
  ref,
) {
  const handleClick = () => {
    onClick(notification);
  };

  const handleCloseClick = (event) => {
    event.stopPropagation();
    onClose(notification);
  };

  const handleKeyDown = (event) => {
    // Ignore keydowns bubbling up from interactive descendants (e.g. the
    // close button) — only activate on keys pressed on the card itself.
    if (event.target !== event.currentTarget) return;
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleClick();
    }
  };

  return (
    <div
      ref={ref}
      className={`noti-card noti-card--${variant} ${
        isUnread ? "is-unread" : "is-read"
      }`}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
    >
      <div className="noti-card-head">
        <div className="noti-card-head-start">
          <span className="noti-card-badge icon icon-bell"></span>
          {heading && <span className="noti-card-heading">{heading}</span>}
        </div>
        {onClose && (
          <IconButton
            className="bs-btn btn-icon noti-card-close"
            onClick={handleCloseClick}
            aria-label="Close"
          >
            <span className="icon icon-close"></span>
          </IconButton>
        )}
      </div>
      <div className="noti-card-body">
        <p className="noti-card-title">{notification.notificationSubject}</p>
        <p className="noti-card-message">{notification.notificationMessage}</p>
      </div>
      <div className="noti-card-meta">
        <span className="noti-card-meta-item">
          Unit Number : {notification.unitName}
        </span>
        {notification.createdAt && (
          <span className="noti-card-meta-item">
            {formatRelativeTime(notification.createdAt)}
          </span>
        )}
      </div>
    </div>
  );
});

export default NotificationCard;
